/**
 * Resolves a video/animation ID from response objects with various field names
 * @param {Object} obj - Object containing video/animation IDs
 * @returns {string|null} The resolved video/animation ID or null if not found
 */
export function resolveVideoId(obj) {
  if (!obj || typeof obj !== 'object') return null;

  const candidates = [
    obj.videoId,
    obj.videoID,
    obj.animationID,
    obj.animationId,
    obj.aiAnimationGuid,
  ];

  for (const candidate of candidates) {
    if (candidate) return candidate;
  }

  return null;
}

/**
 * Resolves animation GUID from generation response with fallback paths
 * @param {Object} response - API response from generateAnimation
 * @returns {string|null} The animation GUID or null if not found
 */
export function resolveAnimationGuid(response) {
  if (!response || typeof response !== 'object') return null;

  return (
    response.aiAnimationGuid ||
    response.animationID ||
    response.animationId ||
    null
  );
}

/**
 * Resolves video ID from status response with ordered precedence
 * @param {Object} statusResponse - Status response from checkStatus
 * @param {string} animationGuid - Fallback animation GUID
 * @returns {string|null} The resolved video ID or animation GUID
 */
export function resolveVideoIdFromStatus(statusResponse, animationGuid = null) {
  if (!statusResponse || typeof statusResponse !== 'object') {
    return animationGuid || null;
  }

  return (
    statusResponse.videoId ||
    statusResponse.videoID ||
    statusResponse.animationID ||
    statusResponse.animationId ||
    animationGuid ||
    null
  );
}